import React from 'react';
import { useTranslation } from 'react-i18next';

const LoginAttempts = ({ failedAttempts, isDisabled, timeLeft, remainingAttempts, maxAttempts }) => {
    const { t } = useTranslation();

    const calculateTimeout = (attempts) => {
        if (attempts >= 3) {
            return 30 * (attempts - 2);
        }
        return 0;
    };

    if (failedAttempts > 0 && !isDisabled) {
        return (
            <div className="mb-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center">
                        <span className="text-yellow-600 font-bold">{remainingAttempts}</span>
                    </div>
                    <span className="text-sm text-yellow-700 font-medium">
                        {t("attemptsLeft")}
                    </span>
                </div>
                <div className="mt-2">
                    <div className="w-full bg-yellow-200 rounded-full h-1.5">
                        <div
                            className="bg-yellow-600 h-1.5 rounded-full transition-all duration-300"
                            style={{ width: `${(remainingAttempts / maxAttempts) * 100}%` }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }

    if (isDisabled) {
        const timeoutDuration = calculateTimeout(failedAttempts);
        return (
            <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                        <span className="text-red-600 font-bold">{timeLeft}</span>
                    </div>
                    <span className="text-sm text-red-700 font-medium">
                        {t("tryAgainIn")} {t("seconds")}
                    </span>
                </div>
                <div className="mt-2">
                    <div className="w-full bg-red-200 rounded-full h-1.5">
                        <div
                            className="bg-red-600 h-1.5 rounded-full transition-all duration-300"
                            style={{ width: `${(timeLeft / timeoutDuration) * 100}%` }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default LoginAttempts; 